import React from 'react';
import { Button } from './ui/button';

/**
 * Reusable Empty State Component
 * @param {string} icon - Lucide icon component
 * @param {string} title - Main heading
 * @param {string} description - Supporting text
 * @param {string} actionLabel - Button text
 * @param {function} onAction - Button click handler
 * @param {string} secondaryText - Optional secondary help text
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryText,
  actionVariant = 'default'
}) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      {Icon && (
        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-gray-400" />
        </div>
      )}
      
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {title}
      </h3>
      
      <p className="text-sm text-gray-600 max-w-md mb-6">
        {description}
      </p>
      
      {actionLabel && onAction && (
        <Button onClick={onAction} variant={actionVariant} size="lg">
          {actionLabel}
        </Button>
      )}
      
      {secondaryText && (
        <p className="text-xs text-gray-500 mt-4 max-w-sm">
          {secondaryText}
        </p>
      )}
    </div>
  );
}
